import styles from "./style.module.scss";
import React from "react";
import { parseHtml } from "@/utils/common";
import Section from "@/Components/LayoutComponents/Section";

const ProjectOverView: React.FC<any> = ({ data }) => {
  const innerBlocks =
    data?.keyPoints?.map((element: any) => {
      const string = element?.title.trim().split(" ").join("-").toLowerCase();
      return { ...element, anchorTag: `${string}` };
    }) || [];

  return (
    <Section
      className={`${styles["project-overview-section"]} bg-one xl:py-[80px]! md:py-[80px]! py-[60px]!`}
    >
      <div className="container">
        <div className={styles["project-lg-wrapper"]}>
          <div className={`space-y-[80px] xl:container`}>
            {innerBlocks &&
              innerBlocks?.map((point: any, i: number) => {
                const keyPointData = point?.keypoint_blocks
                  ? point?.keypoint_blocks
                  : point?.points
                    ? point?.points
                    : [];

                const sliString = point.title
                  .trim()
                  .split(" ")
                  .join("-")
                  .toLowerCase();

                return (
                  <React.Fragment key={i}>
                    {point.__component === "blocks.casestudy-overview" && (
                      <div
                        className={`${styles["project-lt-list"]} ${styles["casestudy-ck-editor"]}`}
                        id={sliString}
                      >
                        <h2 className="text-heading-4 font-bold text-primary-text">
                          {point.title}
                        </h2>
                        <div
                          className={`space-y-[20px] text-black text-subtitle-1  mt-[24px]`}
                        >
                          {point?.Keypoint &&
                            point?.Keypoint?.map((val: any, ind: number) => {
                              return (
                                <React.Fragment key={`${ind}_ij`}>
                                  {val?.Paragraph &&
                                    val?.Paragraph?.map(
                                      (obj: any, ind2: number) => {
                                        return (
                                          <React.Fragment key={`${ind2}_ij`}>
                                            {obj.description
                                              ? parseHtml(obj.description, true)
                                              : ""}
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </div>
                    )}

                    {point.theme === "Major Challenges" && (
                      <div className={styles["project-lt-list"]} id={sliString}>
                        <h2 className="text-heading-4 md:text-heading-6 font-bold text-primary-text">
                          {point.title}
                        </h2>

                        <ul
                          className={`md:space-y-[30px] space-y-[24px] text-black text-subtitle-1  mt-[24px]`}
                        >
                          {keyPointData &&
                            keyPointData?.map((point: any, i: number) => {
                              return (
                                <li key={`${i}_i`}>
                                  <span className="text-heading-6 font-bold text-green-900 lg:w-[80px] md:w-[64px] w-[48px] lg:h-[80px] md:h-[64px] h-[48px] lg:-mb-[40px] md:-mb-[32px] -mb-[24px] lg:ml-[27px] md:ml-[24px] ml-[16px] flex items-center justify-center bg-green-50 border border-green-100  z-10 relative ">
                                    {String(i + 1).padStart(2, "0")}
                                  </span>
                                  <p className="text-subtitle-1 font-normal text-primary-text lg:pt-[64px] md:pt-[42px] pt-[36px] lg:pb-[30px] md:pb-[20px] pb-[26px] lg:px-[27px] md:px-[24px] px-[16px] border border-green-100">
                                    {point.display_title}
                                  </p>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    )}

                    {point.theme === "Our Solution" && (
                      <div className={styles["project-lt-list"]} id={sliString}>
                        <h2 className="text-heading-4 md:text-heading-6 font-bold text-primary-text">
                          {point.title}
                        </h2>

                        <ul
                          className={`md:space-y-[30px] space-y-[24px] mt-[24px]`}
                        >
                          {keyPointData &&
                            keyPointData?.map((point: any, ind: number) => {
                              return (
                                <li
                                  className={`${styles["collum-list-class"]} text-small  font-medium text-black`}
                                  key={`${ind}_i`}
                                >
                                  <span className="text-heading-6 font-bold text-blue-900 lg:w-[80px] md:w-[64px] w-[48px] lg:h-[80px] md:h-[64px] h-[48px] lg:-mb-[40px] md:-mb-[32px] -mb-[24px] lg:ml-[27px] md:ml-[24px] ml-[16px] flex items-center justify-center bg-blue-50 border border-blue-100 relative z-10">
                                    {String(ind + 1).padStart(2, "0")}
                                  </span>
                                  <p className="text-subtitle-1 font-normal text-primary-text lg:pt-[64px] md:pt-[42px] pt-[36px] lg:pb-[30px] md:pb-[20px] pb-[26px] lg:px-[27px] md:px-[24px] px-[16px] border border-blue-100">
                                    {point.display_title}
                                  </p>

                                  {point?.Keypoint &&
                                    point?.Keypoint?.map((p: any, i: number) => {
                                      return (
                                        <p
                                          className="text-subtitle-1 font-normal text-primary-text pt-[64px] pb-[30px] px-[27px] border border-blue-100"
                                          key={`${i}_pm`}
                                        >
                                          {p.display_title}
                                        </p>
                                      );
                                    })}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    )}

                    {point.theme === "Main Features" && (
                      <div className={styles["project-lt-list"]} id={sliString}>
                        <h2 className="text-heading-4 md:text-heading-6 font-bold text-primary-text">
                          {point.title}
                        </h2>

                        {point?.keypoint_blocks ? (
                          point?.keypoint_blocks?.map(
                            (point: any, ind: number) => {
                              return (
                                <React.Fragment key={`${ind}_j`}>
                                  <h4 className=" mt-[24px]">{point?.title}</h4>
                                  <ul className="grid lg:grid-cols-2 gap-[30px]">
                                    {point?.Keypoint &&
                                      point.Keypoint.map(
                                        (obj: any, indObj: number) => {
                                          return (
                                            <li
                                              key={`${indObj}_o`}
                                              className={`text-subtitle-1 font-regular text-primary-text py-[10px] px-[20px] border-l-[10px] border ${indObj % 2 === 0 ? "border-blue-100" : "border-green-100"}`}
                                            >
                                              {obj.display_title}
                                            </li>
                                          );
                                        }
                                      )}
                                  </ul>
                                </React.Fragment>
                              );
                            }
                          )
                        ) : point?.points?.length > 0 ? (
                          <ul className="grid lg:grid-cols-2 gap-[30px]  mt-[24px]">
                            {point?.points?.map((obj: any, ind: number) => {
                              return (
                                <li
                                  key={`${ind}_o`}
                                  className={`text-subtitle-1 font-regular text-primary-text py-[10px] px-[20px] border-l-[10px] border ${ind % 2 === 0 ? "border-blue-100" : "border-green-100"}`}
                                >
                                  {obj.display_title}
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}

                    {point.theme === "System Functionalities" && (
                      <div className={styles["project-lt-list"]} id={sliString}>
                        <h2 className="text-heading-4 font-bold text-primary-text">
                          {point.ttle}
                        </h2>

                        {point?.keypoint_blocks &&
                          point?.keypoint_blocks?.map(
                            (point: any, ind: number) => {
                              return (
                                <div className={`mt-[24px]`} key={`${ind}_j`}>
                                  <h4>{point.display_title}</h4>
                                  <ul className={styles["static-operate-list"]}>
                                    {point?.Keypoint &&
                                      point?.Keypoint?.map(
                                        (p: any, i: number) => {
                                          return (
                                            <li
                                              key={`${i}_pm`}
                                              className={
                                                styles["collum-list-class"]
                                              }
                                            >
                                              {p.display_title}
                                              {p?.points &&
                                                p?.points?.map(
                                                  (poi: any, ind3: number) => {
                                                    return (
                                                      <p key={`${ind3}_q`}>
                                                        {poi.display_title}
                                                      </p>
                                                    );
                                                  }
                                                )}
                                            </li>
                                          );
                                        }
                                      )}
                                  </ul>
                                </div>
                              );
                            }
                          )}
                      </div>
                    )}

                    {point.__component === "blocks.technology-tech-stack" && (
                      <div className={styles["project-lt-list"]} id={sliString}>
                        <h2 className="text-heading-4 font-bold text-primary-text">
                          {point.ttle}
                        </h2>
                        <div className={`ul-unset  mt-[24px]`}>
                          <ul>
                            {point?.technologies?.map((technology: any) => (
                              <li key={technology?.id}>
                                <span className={styles["name"]}>
                                  {technology?.Title}
                                </span>
                                <span>:</span>
                                {technology?.["sub-tech"]?.map((subTech:any) => (
                                  <span
                                    key={subTech?.id}
                                    className={styles["value"]}
                                  >
                                    {subTech?.display_title}
                                  </span>
                                ))}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}

                    {point.__component === "blocks.stack-holder" && (
                      <div className={styles["project-lt-list"]} id={sliString}>
                        <h2 className="text-heading-4 md:text-heading-6 font-bold text-primary-text">
                          {point.title}
                        </h2>
                        <ul className={` mt-[24px]`}>
                          {point?.stacks &&
                            point?.stacks?.map((obj:any, i: number) => {
                              return (
                                <li
                                  key={`${i}_pl`}
                                  className="flex flex-wrap justify-start items-center gap-[30px]"
                                >
                                  {obj.title && <span>{obj.title}</span>}
                                  {obj?.points &&
                                    obj?.points?.map((p:any, index: number) => {
                                      return (
                                        <p
                                          key={`${index}_l`}
                                          className={`text-subtitle-1 font-semibold text-primary-text py-[14px] px-[16px] border ${index % 2 === 0 ? "border-blue-100" : "border-green-100"}`}
                                        >
                                          {p.title}
                                        </p>
                                      );
                                    })}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default ProjectOverView;